/**
 * Passport Quantity Modal
 * Manages the passport pack selection modal functionality
 */

document.addEventListener('DOMContentLoaded', () => {
  const upgradePackCard = document.querySelector('.upgrade-pack-card');
  const modal = document.querySelector('#passportModal');
  const closeTriggers = modal?.querySelectorAll('[data-close]');
  const optionsGrid = document.getElementById('optionsGrid');
  const packCards = optionsGrid?.querySelectorAll('.pack-card') || [];
  const quantityStep = document.getElementById('quantity-step');
  const productStep = document.getElementById('product-step');
  const confirmBtn = document.getElementById('confirmQuantity');
  const backBtn = document.getElementById('backToQuantity');
  const productGrids = document.querySelectorAll('.product-grid');
  const defaultPackHandle = document.querySelector('.passport-quantity-tabs')?.dataset.currentPack;

  let selectedPackHandle = null;

  console.log('Passport Modal JS loaded');
  console.log('Upgrade card found:', upgradePackCard);
  console.log('Modal found:', modal);
  console.log('Default pack handle:', defaultPackHandle);

  // Append modal to body
  if (modal && modal.parentNode !== document.body) {
    document.body.appendChild(modal);
  }

  // --- Upgrade Pack Card ---
  upgradePackCard?.addEventListener('click', () => {
    console.log('Upgrade button clicked!');
    console.log('Modal element:', modal);
    console.log('Modal classes before:', modal?.classList);

    if (modal) {
      modal.classList.add('open');
      console.log('Modal classes after:', modal.classList);
      console.log('Modal computed style:', window.getComputedStyle(modal).display);
    } else {
      console.error('Modal element not found!');
    }

    // Auto-select the "most popular" card
    const mostPopularCard = Array.from(packCards).find((card) => card.dataset.mostPopular === 'true');

    if (mostPopularCard) {
      packCards.forEach((card) => card.classList.remove('selected'));
      mostPopularCard.classList.add('selected');
      selectedPackHandle = mostPopularCard.dataset.packHandle;
      if (confirmBtn) {
        confirmBtn.disabled = false;
      }
    } else {
      // Fallback: Auto-select matching card based on current pack
      packCards.forEach((card) => {
        card.classList.toggle('selected', card.dataset.packHandle === defaultPackHandle);
      });
      selectedPackHandle = defaultPackHandle;
      if (confirmBtn) {
        confirmBtn.disabled = false;
      }
    }
  });

  // --- Card selection ---
  packCards.forEach((card) => {
    card.addEventListener('click', () => {
      packCards.forEach((c) => c.classList.remove('selected'));
      card.classList.add('selected');
      selectedPackHandle = card.dataset.packHandle;
      confirmBtn.disabled = false;
    });
  });

  // --- Confirm step ---
  confirmBtn?.addEventListener('click', () => {
    if (!selectedPackHandle) return;

    // Update step 2 header with selected pack info
    const titleTexts = document.querySelectorAll('.pack-title-text');
    const subtitleTexts = document.querySelectorAll('.pack-subtitle-text');

    titleTexts.forEach((text) => {
      text.classList.toggle('hidden', text.dataset.packHandle !== selectedPackHandle);
    });

    subtitleTexts.forEach((text) => {
      text.classList.toggle('hidden', text.dataset.packHandle !== selectedPackHandle);
    });

    quantityStep.classList.remove('active');
    productStep.classList.add('active');

    productGrids.forEach((grid) => grid.classList.add('hidden'));
    const targetGrid = document.querySelector(`.product-grid[data-pack-handle="${selectedPackHandle}"]`);
    if (targetGrid) {
      targetGrid.classList.remove('hidden');
      targetGrid.scrollTop = 0; // reset scroll inside the grid
    }
  });

  // --- Back step ---
  backBtn?.addEventListener('click', () => {
    productStep.classList.remove('active');
    quantityStep.classList.add('active');
    productGrids.forEach((grid) => grid.classList.add('hidden'));
  });

  // --- Close modal ---
  closeTriggers?.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      modal.classList.remove('open');
      quantityStep.classList.add('active');
      productStep.classList.remove('active');

      selectedPackHandle = defaultPackHandle;
    });
  });
});
